import { Injectable } from '@angular/core';
import {
  BuiltInPageItemDataService,
  InstalledAppsPageItemDataService,
  RecentlyWatchedTvPageItemDataService,
  TopTenLiveTvPageItemDataService,
  OtherAppsPageItemDataService,
  VodContentPageItemDataService,
  RecommendedAppsPageItemDataService,
  CurrentlyOnTvPageItemDataService,
  SpotlightPageItemDataService,
  SearchTagsPageItemDataService,
  UpcomingLiveTvPageItemDataService,
  FullscreenPageItemDataService,
  BannersCtaPageItemDataService,
  TvChannelLogoPageItemDataService,
  TopTenVodContentPageItemDataService,
  BannersPageItemDataService,
  CollectionsPageItemDataService,
  ChannelSpecificUpcomingPageItemDataService,
  RecommendationPageItemDataService,
  RecommendedChannelsPageItemDataService,
  MarketingBannerPageItemDataService,
  TvSeasonPageItemDataService,
  SeasonPageItemDataService,
  MarketingEmailBlockerPageItemDataService,
  MarketingSpotlightCtaPageItemDataService,
  GenrePageItemDataService,
  StudioPageItemDataService,
  CarouselPageItemDataService,
  MarketingHeroPageItemDataService,
  MarketingFaqPageItemDataService,
  MarketingPartnerVoucherPageItemDataService,
  MarketingRedeemCtaPageItemDataService,
  MarketingBulletedUspPageItemDataService,
  MarketingDetailPageItemDataService,
  MarketingDeviceCtaPageItemDataService,
  MarketingPageItemUspDataService,
  MarketingTargetedFaqPageItemDataService,
  HeroDataService,
  MarketingGenericVoucherPageItemDataService,
  MarketingPageItemKidsDataService,
  MarketingPageItemStudioDataService,
  MarketingPageItemTrendingDataService,
  MarketingPageItemEmailDataService,
  MarketingPageItemCtaDataService,
  ChannelSpecificCatchUpPageItemDataService,
  CatchUpPageItemDataService,
  MarketingPageItemVideoDataService,
  MarketingPageItemBarDataService,
  LandscapePageItemDataService,
  CategoryPageItemDataService,
  OndemandBannerPageItemDataService,
  MixedSearchTagPageItemDataService,
} from '@cxb/editor-stb-api';
import { Observable } from 'rxjs';
import { PageItemType } from '../domain/page-item-type';
import { PageType } from '../page-edit-screen/page-type';
import { Tenant } from '../domain/tenant';

@Injectable({ providedIn: 'root' })
export class TrayApiDeleteService {
  constructor(
    private readonly marketingHeroDataService: MarketingHeroPageItemDataService,
    private readonly marketingDetailPageItemDataService: MarketingDetailPageItemDataService,
    private readonly uspDataService: MarketingPageItemUspDataService,
    private readonly marketingCtaDataService: MarketingPageItemCtaDataService,
    private readonly carouselDataService: CarouselPageItemDataService,
    private readonly redeemPartnerVoucherTrayDataService: MarketingPartnerVoucherPageItemDataService,
    private readonly redeemGenericVoucherTrayDataService: MarketingGenericVoucherPageItemDataService, // AXB-1175
    private readonly redeemCtaTrayDataService: MarketingRedeemCtaPageItemDataService,
    private readonly redeemUspTrayDataService: MarketingBulletedUspPageItemDataService,
    private readonly faqTrayDataService: MarketingFaqPageItemDataService,
    private readonly targetedFaqTrayDataService: MarketingTargetedFaqPageItemDataService,
    private readonly seasonTrayDataService: TvSeasonPageItemDataService,
    private readonly singlePhotoSeasonTrayDataService: SeasonPageItemDataService,
    private readonly genrePageItemDataService: GenrePageItemDataService,
    private readonly studioPageItemDataService: StudioPageItemDataService,
    private readonly builtInDataService: BuiltInPageItemDataService,
    private readonly installedAppsPageItemDataService: InstalledAppsPageItemDataService,
    private readonly recommendedAppsPageItemDataService: RecommendedAppsPageItemDataService,
    private readonly otherAppsDataService: OtherAppsPageItemDataService,
    private readonly topTenVodContentPageItemDataService: TopTenVodContentPageItemDataService,
    private readonly recentlyWatchedTvPageItemDataService: RecentlyWatchedTvPageItemDataService,
    private readonly topTenLiveTvPageItemDataService: TopTenLiveTvPageItemDataService,
    private readonly currentlyOnTvPageItemDataService: CurrentlyOnTvPageItemDataService,
    private readonly spotlightPageItemDataService: SpotlightPageItemDataService,
    private readonly marketingBannerPageItemDataService: MarketingBannerPageItemDataService,
    private readonly searchTagsPageItemDataService: SearchTagsPageItemDataService,
    private readonly tvChannelLogoPageItemDataService: TvChannelLogoPageItemDataService,
    private readonly vodContentPageItemDataService: VodContentPageItemDataService,
    private readonly upcomingLiveTvPageItemDataService: UpcomingLiveTvPageItemDataService,
    private readonly fullscreenPageItemDataService: FullscreenPageItemDataService,
    private readonly bannersCtaPageItemDataService: BannersCtaPageItemDataService,
    private readonly bannersPageItemDataService: BannersPageItemDataService,
    private readonly collectionsPageItemDataService: CollectionsPageItemDataService,
    private readonly channelSpecificUpcomingPageItemDataService: ChannelSpecificUpcomingPageItemDataService,
    private readonly recommendationPageItemDataService: RecommendationPageItemDataService,
    private readonly recommendedChannelsPageItemDataService: RecommendedChannelsPageItemDataService,
    private readonly marketingEmailBlockerPageItemDataService: MarketingEmailBlockerPageItemDataService,
    private readonly spotlightTrayDataService: MarketingSpotlightCtaPageItemDataService,
    private readonly deviceModuleTrayDataService: MarketingDeviceCtaPageItemDataService,
    private readonly heroDataService: HeroDataService,
    private readonly kidsDataService: MarketingPageItemKidsDataService,
    private readonly studioDataService: MarketingPageItemStudioDataService,
    private readonly trendingDataService: MarketingPageItemTrendingDataService,
    private readonly marketingEmailDataService: MarketingPageItemEmailDataService,
    private readonly catchUpPageItemDataService: CatchUpPageItemDataService,
    private readonly channelSpecificCatchUpPageItemDataService: ChannelSpecificCatchUpPageItemDataService,
    private readonly marketingPageItemVideoDataService: MarketingPageItemVideoDataService,
    private readonly marketingPageItemBarDataService: MarketingPageItemBarDataService,
    private readonly landscapePageItemDataService: LandscapePageItemDataService,
    private readonly categoryPageItemDataService: CategoryPageItemDataService,
    private readonly ondemandBannerPageItemDataService: OndemandBannerPageItemDataService,
    private readonly mixedSearchTagPageItemDataService: MixedSearchTagPageItemDataService
  ) {}

  public deletePageItem$(id: string, type: PageItemType, pageType: PageType, selectedTenant?: Tenant): Observable<unknown> {
    // eslint-disable-next-line sonarjs/max-switch-cases
    switch (type) {
      case 'PortraitTray':
      case 'TopTenTray':
      case 'CollectionTray':
        return this.carouselDataService.deleteCarouselPageItem(id, selectedTenant?.id);
      case 'BuiltIn':
        return this.builtInDataService.deleteBuiltInPageItem(id, selectedTenant?.id);
      case 'MarketingCta':
        return this.marketingCtaDataService.deleteMarketingPageItemCta(id, selectedTenant?.id);
      case 'MarketingUsp':
        return this.uspDataService.deleteMarketingPageItemUsp(id, selectedTenant?.id);
      case 'MarketingStudio':
        return this.studioDataService.deleteMarketingPageItemStudio(id, selectedTenant?.id);
      case 'MarketingTrending':
        return this.trendingDataService.deleteMarketingPageItemTrending(id, selectedTenant?.id);
      // CXB
      case 'MarketingHero':
        return this.marketingHeroDataService.deleteMarketingHeroPageItem(id, selectedTenant?.id);
      case 'DetailedPageMarketingBanner':
        return this.marketingDetailPageItemDataService.deleteMarketingDetailPageItem(id, selectedTenant?.id);
      case 'RedeemGenericVoucherTray':
        return this.redeemGenericVoucherTrayDataService.deleteMarketingGenericVoucherPageItem(id, selectedTenant?.id);
      case 'RedeemPartnerVoucherTray':
        return this.redeemPartnerVoucherTrayDataService.deleteMarketingPartnerVoucherPageItem(id, selectedTenant?.id);
      case 'RedeemCtaTray':
        return this.redeemCtaTrayDataService.deleteMarketingRedeemCtaPageItem(id, selectedTenant?.id);
      case 'RedeemUspTray':
        return this.redeemUspTrayDataService.deleteMarketingBulletedUspPageItem(id, selectedTenant?.id);
      case 'FaqTray':
        return pageType === PageType.redeem
          ? this.faqTrayDataService.deleteMarketingFaqPageItem(id, selectedTenant?.id)
          : this.targetedFaqTrayDataService.deleteMarketingTargetedFaqPageItem(id, selectedTenant?.id);
      case 'SeasonTray':
        return this.seasonTrayDataService.deleteTvSeasonPageItem(id, selectedTenant?.id);
      case 'SinglePhotoSeasonTray':
        return this.singlePhotoSeasonTrayDataService.deleteSeasonPageItem(id, selectedTenant?.id);
      case 'Hero':
        return this.heroDataService.deleteHero(id, selectedTenant?.id);
      // UXB
      case 'Recommendation':
        return this.recommendationPageItemDataService.deleteRecommendationPageItem(id, selectedTenant?.id);
      case 'BuiltIn':
      case 'MyFavouritesOnLiveTV': // AXB-71
      case 'LiveTVReminders': // AXB-84
      case 'ContinueWatchingTray': // AXB-79
      case 'MyListTray': // AXB-80
      case 'TVGuide': // AXB-78
        return this.builtInDataService.deleteBuiltInPageItem(id, selectedTenant?.id);
      case 'TitleImagePortraitTray': // AXB-89
        return this.otherAppsDataService.deleteOtherAppsPageItem(id, selectedTenant?.id);
      case 'StreamingContentTray': // AXB-81
        return this.vodContentPageItemDataService.deleteVodContentPageItem(id, selectedTenant?.id);
      case 'TopTenOnOSNPlusPosterArtTray':
        return this.topTenVodContentPageItemDataService.deleteTopTenVodContentPageItem(id, selectedTenant?.id);
      case 'CurrentlyOnTvTray': // AXB-73
        return this.currentlyOnTvPageItemDataService.deleteCurrentlyOnTvPageItem(id, selectedTenant?.id);
      case 'ChannelLogoTray': // AXB-76
        return this.tvChannelLogoPageItemDataService.deleteTvChannelLogoPageItem(id, selectedTenant?.id);
      case 'TopTenOnLiveTvTray': //AXB-75
        return this.topTenLiveTvPageItemDataService.deleteTopTenLiveTvPageItem(id, selectedTenant?.id);
      case 'AppsAndGamesRecommendedApps': // AXB-69
        return this.recommendedAppsPageItemDataService.deleteRecommendedAppsPageItem(id, selectedTenant?.id);
      case 'AppsAndGamesInstalledApps': // AXB-70
        return this.installedAppsPageItemDataService.deleteInstalledAppsPageItem(id, selectedTenant?.id);
      case 'RecentlyWatchedTV':
        return this.recentlyWatchedTvPageItemDataService.deleteRecentlyWatchedTvPageItem(id, selectedTenant?.id);
      case 'HeroSpotlight':
        return this.spotlightPageItemDataService.deleteSpotlightPageItem(id, selectedTenant?.id);
      case 'SearchTagsTray': //AXB-172
        return this.searchTagsPageItemDataService.deleteSearchTagsPageItem(id, selectedTenant?.id);
      case 'ComingSoonForLiveTvTray': //AXB-74
        return this.upcomingLiveTvPageItemDataService.deleteUpcomingLiveTvPageItem(id, selectedTenant?.id);
      case 'FullscreenTray': // AXB-72
        return this.fullscreenPageItemDataService.deleteFullscreenPageItem(id, selectedTenant?.id);
      case 'BannersTrayWithCta': //AXB-86
        return this.bannersCtaPageItemDataService.deleteBannersWithCtaPageItem(id, selectedTenant?.id);
      case 'CarouselTray': // AXB-87
        return this.bannersPageItemDataService.deleteBannersPageItem(id, selectedTenant?.id);
      case 'CarouselBannerTray': // AXB-88
        return this.collectionsPageItemDataService.deleteCollectionsPageItem(id, selectedTenant?.id);
      case 'UpcomingOnSpecificTvChannelTray': //AXB-73
        return this.channelSpecificUpcomingPageItemDataService.deleteChannelSpecificUpcomingPageItem(id, selectedTenant?.id);
      case 'RecommendedChannelsTray': //AXB-194
        return this.recommendedChannelsPageItemDataService.deleteRecommendedChannelsPageItem(id, selectedTenant?.id);
      case 'MarketingBannerTray': //AXB-330
        return this.marketingBannerPageItemDataService.deleteMarketingBannerPageItem(id, selectedTenant?.id);
      case 'MarketingEmailBlocker':
        return this.marketingEmailBlockerPageItemDataService.deleteMarketingEmailBlockerPageItem(id, selectedTenant?.id);
      case 'SpotlightTray':
        return this.spotlightTrayDataService.deleteMarketingSpotlightCtaPageItem(id, selectedTenant?.id);
      case 'GenreTray':
        return this.genrePageItemDataService.deleteGenrePageItem(id, selectedTenant?.id);
      case 'StudiosTray':
        return this.studioPageItemDataService.deleteStudioPageItem(id, selectedTenant?.id);
      case 'DeviceModuleTray':
        return this.deviceModuleTrayDataService.deleteMarketingDeviceCtaPageItem(id, selectedTenant?.id);
      case 'MarketingKids':
        return this.kidsDataService.deleteMarketingPageItemKids(id, selectedTenant?.id);
      case 'MarketingTrending':
        return this.trendingDataService.deleteMarketingPageItemTrending(id, selectedTenant?.id);
      case 'MarketingStudio':
        return this.studioDataService.deleteMarketingPageItemStudio(id, selectedTenant?.id);
      case 'MarketingEmailCollector':
        return this.marketingEmailDataService.deleteMarketingPageItemEmail(id, selectedTenant?.id);
      case 'CatchUpTray':
        return this.catchUpPageItemDataService.deleteCatchUpPageItem(id, selectedTenant?.id);
      case 'ChannelSpecificCatchUpTray':
        return this.channelSpecificCatchUpPageItemDataService.deleteChannelSpecificCatchUpPageItem(id, selectedTenant?.id);
      case 'MarketingVideoTray':
        return this.marketingPageItemVideoDataService.deleteMarketingVideoPageItem(id, selectedTenant?.id);
      case 'MarketingBarTray':
        return this.marketingPageItemBarDataService.deleteMarketingBarPageItem(id, selectedTenant.id);
      case 'LandscapeTray':
        return this.landscapePageItemDataService.deleteLandscapePageItem(id, selectedTenant.id);
      case 'OndemandCategoryTray':
        return this.categoryPageItemDataService.deleteCategoryPageItem(id, selectedTenant.id);
      case 'OndemandBannerTray':
        return this.ondemandBannerPageItemDataService.deleteOndemandBannerPageItem(id, selectedTenant.id);
      case 'MixedSearchTagTray':
        return this.mixedSearchTagPageItemDataService.deleteMixedSearchTagPageItem(id, selectedTenant.id);
    }

    throw Error(`Unknown tray type: [${type}]`);
  }
}
